// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Alert_invisible__uusVb {
	opacity: 0;
}

.Alert_terminate__\\+Tl4h {
	display: none;
}

.Alert_alertContainer__RckRu {
	position: fixed;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 100000;
	/* font-family: 'Orbitron', 'Orbitron-Bold', 'Orbitron-Regular' !important; */
}

.Alert_alertMask__1y0cV {
	position: absolute;
	height: 100%;
	top: 0;
	left: 0;
	z-index: -1;
	background-color: rgba(0, 0, 0, 0.3);
}

.Alert_alertDetails__gkR2x {
	min-width: 300px;
	background-color: #fff;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
	letter-spacing: 0.28px;
	border: none;
	border-radius: 10px;
	padding: 10px;
	z-index: 1000000;
}

.Alert_alertMessage__kWzk5 {
	word-break: break-word;
	padding: 10px 15px;
}

.Alert_alertMessageText__DXpRU {
	text-align: center;
	word-break: break-word;
}

.Alert_confirmationBox__LcQyY {
	padding: 5px 30px;
	max-width: 300px;
	gap: 5px;
}

.Alert_button__6rviZ {
	padding: 10px 30px;
	font-size: 16px;
	border-radius: 5px;
}

.Alert_accept__RIaMI {
	background-color: #fff;
	color: #052E26;
	border: 2px solid #052E26;
}

.Alert_accept__RIaMI:hover {
	color: #fff;
	background-color: #052E26;
	border-color: #052E26;
}

.Alert_decline__d\\+FdW {
	background-color: #fff;
	color: #052E26;
	border: 2px solid #fff;
}

.Alert_decline__d\\+FdW:hover {
	border: 2px solid #052E26;
}

.Alert_ok__Nl1et {
	background-color: #fff;
	color: #052E26;
	border: 2px solid #052E26;
}

.Alert_ok__Nl1et:hover {
	color: #fff;
	background-color: #052E26;
	border-color: #052E26;
}

.Alert_ok__Nl1et:disabled {
	cursor: default !important;
	color: transparent;
	background-color: transparent;
	border-color: transparent;
	visibility: 0;
	opacity: 0;
}

.Alert_response__wshxa {
	max-width: 400px;
	display: block;
	padding: 5px;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
	letter-spacing: 0.28px;
	border: 0.5px solid #052E26;
	outline: none !important;
	border-radius: 5px;
	background-color: #fff;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 900px) and (min-width: 761px) {
	.Alert_alertDetails__gkR2x {
		width: 60%;
	}
}

@media only screen and (max-width: 760px) and (min-width: 481px) {
	.Alert_alertDetails__gkR2x {
		width: 70%;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
	.Alert_alertDetails__gkR2x {
		width: 80%;
	}
}

@media only screen and (max-width: 360px) {
	.Alert_alertDetails__gkR2x {
		width: 300px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/Alert.module.css"],"names":[],"mappings":"AAAA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,MAAM;CACN,OAAO;CACP,eAAe;CACf,6EAA6E;AAC9E;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,WAAW;CACX,oCAAoC;AACrC;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,sBAAsB;CACtB,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,6BAA6B;CAC7B,yBAAyB;CACzB,aAAa;CACb,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,sBAAsB;CACtB,2BAA2B;CAC3B,wBAAwB;CACxB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA,yDAAyD;AACzD;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD","sourcesContent":[".invisible {\n\topacity: 0;\n}\n\n.terminate {\n\tdisplay: none;\n}\n\n.alertContainer {\n\tposition: fixed;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 100000;\n\t/* font-family: 'Orbitron', 'Orbitron-Bold', 'Orbitron-Regular' !important; */\n}\n\n.alertMask {\n\tposition: absolute;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tz-index: -1;\n\tbackground-color: rgba(0, 0, 0, 0.3);\n}\n\n.alertDetails {\n\tmin-width: 300px;\n\tbackground-color: #fff;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n\tletter-spacing: 0.28px;\n\tborder: none;\n\tborder-radius: 10px;\n\tpadding: 10px;\n\tz-index: 1000000;\n}\n\n.alertMessage {\n\tword-break: break-word;\n\tpadding: 10px 15px;\n}\n\n.alertMessageText {\n\ttext-align: center;\n\tword-break: break-word;\n}\n\n.confirmationBox {\n\tpadding: 5px 30px;\n\tmax-width: 300px;\n\tgap: 5px;\n}\n\n.button {\n\tpadding: 10px 30px;\n\tfont-size: 16px;\n\tborder-radius: 5px;\n}\n\n.accept {\n\tbackground-color: #fff;\n\tcolor: #052E26;\n\tborder: 2px solid #052E26;\n}\n\n.accept:hover {\n\tcolor: #fff;\n\tbackground-color: #052E26;\n\tborder-color: #052E26;\n}\n\n.decline {\n\tbackground-color: #fff;\n\tcolor: #052E26;\n\tborder: 2px solid #fff;\n}\n\n.decline:hover {\n\tborder: 2px solid #052E26;\n}\n\n.ok {\n\tbackground-color: #fff;\n\tcolor: #052E26;\n\tborder: 2px solid #052E26;\n}\n\n.ok:hover {\n\tcolor: #fff;\n\tbackground-color: #052E26;\n\tborder-color: #052E26;\n}\n\n.ok:disabled {\n\tcursor: default !important;\n\tcolor: transparent;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n\tvisibility: 0;\n\topacity: 0;\n}\n\n.response {\n\tmax-width: 400px;\n\tdisplay: block;\n\tpadding: 5px;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n\tletter-spacing: 0.28px;\n\tborder: 0.5px solid #052E26;\n\toutline: none !important;\n\tborder-radius: 5px;\n\tbackground-color: #fff;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 900px) and (min-width: 761px) {\n\t.alertDetails {\n\t\twidth: 60%;\n\t}\n}\n\n@media only screen and (max-width: 760px) and (min-width: 481px) {\n\t.alertDetails {\n\t\twidth: 70%;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n\t.alertDetails {\n\t\twidth: 80%;\n\t}\n}\n\n@media only screen and (max-width: 360px) {\n\t.alertDetails {\n\t\twidth: 300px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invisible": `Alert_invisible__uusVb`,
	"terminate": `Alert_terminate__+Tl4h`,
	"alertContainer": `Alert_alertContainer__RckRu`,
	"alertMask": `Alert_alertMask__1y0cV`,
	"alertDetails": `Alert_alertDetails__gkR2x`,
	"alertMessage": `Alert_alertMessage__kWzk5`,
	"alertMessageText": `Alert_alertMessageText__DXpRU`,
	"confirmationBox": `Alert_confirmationBox__LcQyY`,
	"button": `Alert_button__6rviZ`,
	"accept": `Alert_accept__RIaMI`,
	"decline": `Alert_decline__d+FdW`,
	"ok": `Alert_ok__Nl1et`,
	"response": `Alert_response__wshxa`
};
export default ___CSS_LOADER_EXPORT___;
